import { render, staticRenderFns } from "./Permisos.vue?vue&type=template&id=d10ac8fa"
import script from "./Permisos.vue?vue&type=script&lang=js"
export * from "./Permisos.vue?vue&type=script&lang=js"
import style0 from "./Permisos.vue?vue&type=style&index=0&id=d10ac8fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports